<template>
  <main v-if="isLoadingPage" class="reset-password-page">
    <div class=" d-flex align-items-center justify-content-center vh-100 bg-light" style="min-height: 100vh; display: flex; justify-content: center; align-items: center; background-color: ghostwhite !important;">
      <i class="fas fa-spinner fa-spin" style="font-size: 40px;"></i>
    </div>
  </main>
  <main v-else class="reset-password-page">
    <div class=" d-flex flex-column align-items-center justify-content-center vh-100 bg-light px-5" style="min-height: 100vh; display: flex; align-items: center; justify-content: center; background-color: ghostwhite !important;">
      <div >
        <div style="height: 120px; margin-bottom: 20px;">
          <img v-bind:src="parentCompanyInfo.logo_login_register" alt="" style="max-width: 100%;max-height: 100%;" v-if="parentCompanyInfo.logo_login_register != ''">
        </div>
      </div>
      <div class="card shadow-lg p-4" style="max-width: 400px; width: 100%;">
        <div class="text-center mb-4">
          <h4 class="mb-1">Reset Your Password</h4>
          <small class="text-muted">Enter your new password below</small>
        </div>

        <ValidationObserver ref="observer" v-slot="{ validate }">
          <form @submit.prevent="handleSubmit">

            <!-- Email -->
            <input
              type="email"
              name="email"
              :value="$route.query.email"
              autocomplete="username"
              hidden
            />

            <!-- Password -->
            <ValidationProvider name="password" rules="required|min:6" v-slot="{ errors, passed, failed }">
              <div class="password-icon">
                <base-input
                  v-model="password"
                  placeholder="New Password"
                  :type="showPassword ? 'text' : 'password'"
                  required
                  autocomplete="new-password"
                  addon-left-icon="tim-icons icon-lock-circle"
                  :error="errors[0]"
                  :class="[{ 'has-success': passed }, { 'has-danger': failed }]"
                />
                <button
                  type="button"
                  class="icon-password-login-register"
                  @click="togglePassword"
                >
                  <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                </button>
              </div>
            </ValidationProvider>

            <!-- Confirm Password -->
            <ValidationProvider
              name="confirm password"
              rules="required|confirmed:password"
              v-slot="{ errors, passed, failed }"
            >
              <div class="password-icon">
                <base-input
                  v-model="confirmPassword"
                  placeholder="Confirm Password"
                  :type="showConfirmPassword ? 'text' : 'password'"
                  required
                  autocomplete="new-password"
                  addon-left-icon="tim-icons icon-lock-circle"
                  :error="errors[0]"
                  :class="[{ 'has-success': passed }, { 'has-danger': failed }]"
                />
                <button
                  type="button"
                  class="icon-password-login-register"
                  @click="toggleConfirmPassword"
                >
                  <i :class="showConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                </button>
              </div>
            </ValidationProvider>


            <div v-if="errors.general" class="text-danger mt-2 text-center">
              {{ errors.general }}
            </div>

            <base-button
              native-type="submit"
              type="primary"
              class="w-100 mt-3"
              :loading="loading"
            >
              {{ loading ? 'Resetting...' : 'Reset Password' }}
            </base-button>

            <!-- Link back to login -->
            <div class="text-center mt-3">
              <small class="text-muted">
                Back to login? 
                <router-link :to="{ name: 'Login' }">Click here</router-link>
              </small>
            </div>

          </form>
        </ValidationObserver>
      </div>
    </div>
  </main>
</template>


<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, min, confirmed } from 'vee-validate/dist/rules';
import { BaseInput, BaseButton } from '/src/components';
import { Notification } from 'element-ui';
import axios from "axios";


extend('required', required);
extend('min', min);
extend('confirmed', confirmed);
axios.defaults.baseURL = process.env.VUE_APP_DATASERVER_URL + "/api";

export default {
  name: 'ResetPassword',
  components: {
    ValidationProvider,
    ValidationObserver,
    BaseInput,
    BaseButton,
  },
  data() {
    return {
      password: '',
      confirmPassword: '',
      showPassword : false,
      showConfirmPassword : false,
      loading: false,
      isLoadingPage: false,
      errors: {},
      loginpict: '',
      parentCompanyInfo: {
        ownedcompanyid: "",
        domain: "",
        subdomain: "",
        logo_login_register: "",
        externalorgid: "",
      },
      tmpUserData : {
        leadlocalname: '',
        leadlocalurl: '',
        leadlocatorname: '',
        leadlocatorurl: '',
      },


    };
  },
  mounted() {
    document.title = 'Reset Password'
    this.checkdomainsubdomain()
  },
  methods: {
    togglePassword() {
        this.showPassword = !this.showPassword
     },
    toggleConfirmPassword() {
        this.showConfirmPassword = !this.showConfirmPassword
    },
    async handleSubmit() {

      const valid = await this.$refs.observer.validate();
      if (!valid) return;

      this.loading = true;

      try {
        const token = this.$route.params.token;
        const email = this.$route.query.email;

        const res = await axios.post('/reset-password', {
          token,
          email,
          password: this.password,
          password_confirmation: this.confirmPassword,
          ownedcompanyid: this.parentCompanyInfo.ownedcompanyid,
          companyrootid: this.$global.idsys,
        });

        if (res.data.success) {
          Notification.success({
            title: 'Success',
            message: 'Your password has been reset successfully. You will be redirected to the login page shortly.',
            customClass: 'success-notification'
          });

          setTimeout(() => {
            this.$router.push({ name: 'Login' });
          }, 3000); // 3 seconds delay
        }else{
          Notification.error({
            title: 'Error',
            message: res.data.message || 'Token invalid.',
            customClass: 'error-notification'
          });
        }

      } catch (err) {
        const msg = (err.response && err.response.data && err.response.data.message) || 'Something went wrong.';

        Notification.error({
          title: 'Error',
          message: msg,
          customClass: 'error-notification'
        });

      } finally {
        this.loading = false;
      }
    },
    async checkdomainsubdomain() {
      this.isLoadingPage = true
      var currurl = window.location.hostname      
      const mainDomain = currurl.replace(/(.*?)\.(?=.*\.)/, '');

      await this.$store.dispatch('getDomainorSubInfo', {
          domainorsub: window.location.hostname,
        }).then(response => {
            $('link[rel="icon"]').attr('href', response.params.logo_login_register);
            $('link[rel="apple-touch-icon"]').attr('href', response.params.logo_login_register);
            $('meta[name="apple-mobile-web-app-title"]').attr('content',response.params.companyname);

            if (response.params.ownedcompanyid == "") {
              document.location = 'https://' + response.params.subdomain;
            }
            this.parentCompanyInfo.ownedcompanyid = response.params.ownedcompanyid;
            this.parentCompanyInfo.domain = response.params.domain;
            this.parentCompanyInfosubdomain = response.params.subdomain;
            this.parentCompanyInfo.logo_login_register = response.params.logo_login_register;
            this.parentCompanyInfo.externalorgid  = response.params.externalorgid;
            this.loginpict = response.params.login_image;
            this.layoutready = true;
            this.$global.idsys = response.params.idsys;
            this.$global.recapkey = response.params.recapkey;
            this.sitekey = response.params.recapkey;
            document.title = response.params.companyname + " Reset Password";
            this.isLoadingPage = false

        },error => {
            this.isLoadingPage = false
            document.location = 'https://' + mainDomain;
        })
    },
  }
};
</script>

<style>
.full-page > .content {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.reset-password-page .full-page > .content {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
</style>


